import type { TestContext, TestFunction } from 'yup';

import { validatePassport } from 'shared/api/daData';

const passports = new Map<string, Promise<boolean | null>>();
const passportCleanupTimers = new Map<string, NodeJS.Timeout>();

const CACHE_TTL = 60 * 1000; // 1 минута

const setAutoCleanup = (passportSN: string) => {
  if (passportCleanupTimers.has(passportSN)) {
    clearTimeout(passportCleanupTimers.get(passportSN));
  }

  const timer = setTimeout(() => {
    passports.delete(passportSN);
    passportCleanupTimers.delete(passportSN);
  }, CACHE_TTL);

  passportCleanupTimers.set(passportSN, timer);
};

export const isActivePassport: TestFunction = async (value, testContext) => {
  const context = testContext.parent ? testContext : (testContext.options.context as TestContext);
  const passportSN = String(value).replace(/\D/g, '');
  if (passportSN.length !== 10) {
    return context.createError({ path: context.path, message: 'Укажите корректный номер' });
  }

  // todo разобраться, как передавать запрос на валидацию паспорта в yup через RTK Query и убрать костыль с кэшированием
  if (!passports.has(passportSN)) {
    const validationPromise = validatePassport(passportSN);
    passports.set(passportSN, validationPromise);
    validationPromise.then(() => setAutoCleanup(passportSN));
  }

  const isValid = await passports.get(passportSN);

  if (isValid === null) {
    passports.delete(passportSN);
  }

  return Boolean(isValid) || context.createError({ path: context.path, message: 'Укажите корректный номер' });
};
